module.exports = __webpack_public_path__ + "img/ccdsjiaotongtopnew.831ec88e.png";